import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable, BehaviorSubject } from 'rxjs';
import 'rxjs/Rx';
import { HttpClient } from '@angular/common/http';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { DataSourceRequestState, DataResult } from '@progress/kendo-data-query';
import { AppConstant } from 'src/app/app.constant';
import { Attachment, Mail, ManageMail } from './mail.classes';
import { CoreHelperService } from 'src/app/services/core/core-helper.service';

@Injectable()
export class MailService {
    apiUrl: string;
    kendoDataUrl: string;

    constructor(
        private httpClient: HttpClient,
        private appConstant: AppConstant,
        public coreHelperService: CoreHelperService) {
        this.apiUrl = this.appConstant.getUrl();
    }

    getAllMailsKendo(userId: number, state: DataSourceRequestState): Observable<DataResult> {
        const params = {
            userId: userId,
            state: state
        }

        return this.httpClient.post(`${this.apiUrl}/emailListKendo/`, params).pipe(
            map((response: any) => {

                const data = response.data
                const total = response.total
                return { data, total } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }

    getAllInboxEmail(userId: number, state: DataSourceRequestState, searchText: string): Observable<DataResult> {
        return this.getMails(userId, state, 'getAllInboxEmail', searchText);
    }

    getAllOutboxEmail(userId: number, state: DataSourceRequestState, searchText: string): Observable<DataResult> {
        return this.getMails(userId, state, 'getAllOutboxEmail', searchText);
    }

    getAllStarredEmail(userId: number, state: DataSourceRequestState, searchText: string): Observable<DataResult> {
        return this.getMails(userId, state, 'getAllStarredEmail', searchText);
    }

    getAllMarkedEmail(userId: number, state: DataSourceRequestState, searchText: string): Observable<DataResult> {
        return this.getMails(userId, state, 'getAllMarkedEmail', searchText);
    }

    private getMails(userId: number, state: DataSourceRequestState, api: string, searchText: string): Observable<DataResult> {
        let searchTextApi = '';
        if (!this.coreHelperService.isStringEmptyOrWhitespace(searchText)) {
            searchTextApi = '?search=' + searchText;
        }
        return this.httpClient.post(`${this.apiUrl}/${api}${searchTextApi}`, {
            userId: userId,
            state: state
        }).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult;
            })
        ) as any as Observable<GridDataResult>;
    }

    sendMail(mail) {
        return this.httpClient.post(`${this.apiUrl}/sendEmail`, mail)
            .pipe(map((response) => {
                return response;
            }));
    }

    sendUserMail(mail) {
        return this.httpClient.post(`${this.apiUrl}/userMail`, mail).pipe(map((response) => {
            return response;
        }));
    }

    addAttachments(attachments: Attachment[]) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(`${this.apiUrl}/fileBulkUpload`, attachments).map(res => res)
                .subscribe(res => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
        });
    }

    getEmailById(mailId: number): Observable<Mail> {
        return this.httpClient.get(`${this.apiUrl}/getEmailById/` + mailId).pipe(
            map((response: any) => {
                return response.data;
            })
        ) as any as Observable<Mail>;
    }

    manageMail(manageMail: ManageMail) {
        return this.httpClient.post(`${this.apiUrl}/manageEmail`, manageMail).pipe(map((response) => {
            return response;
        }));
    }

    getUserByBranchId(branchId: number) {
        return this.httpClient.get(`${this.apiUrl}/userByBranchId/` + branchId).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
}